<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="ch02">
<h1 class="ct"><a class="xref" href="#/wsuridl0007#rch02">It Was Last Night, I Think</a></h1>
<div class="senseline">
<p class="sl">During the storm,</p>
<p class="sl">I wondered</p>
<p class="sl">about gathering</p>
<p class="sl">all the drops.</p>
<p class="sl">From there it</p>
<p class="sl">took off into all</p>
<p class="sl">this other stuff: light</p>
<p class="sl">on the underside</p>
<p class="sl">of leaves, what</p>
<p class="sl">rust peels away,</p>
<p class="sl">the space between</p>
<p class="sl">musical notes. I forgot</p>
<p class="sl">what time it was; I</p>
<p class="sl">wrote that down.</p>
<p class="sl">When I was a kid</p>
<p class="sl">I loved plus signs</p>
<p class="sl">and hummingbirds</p>
<p class="sl">in the honeysuckle.</p>
<p class="sl">I have jars filled</p>
<p class="sl">with words my</p>
<p class="sl">father left behind.</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-ridl-0010.vue?e2b918a8